// extracted by mini-css-extract-plugin
export var standaloneTable = "_29-0";
export var standaloneTableWithBodyFill = "_29-1";
export var withExtraHeader = "_29-2";